import {
    ViewListingContainer,
    ViewListingFeaturedImage,
    ViewListingTitleWrapper,
    ViewListingTitleTitle,
    ViewListingTitleSubtitle,
    ViewListingTitleAmenities,
    ViewListingSubtitleWrapper,
    ViewListingTopContainerWrapper,
    ViewListingTopContainer,
    ViewListingRightMenuContainer,
    SkeletonViewListingPageContainer,
    SkeletonCarouselWrapper,
    SkeletonCarouselPageContainer,
    SkeletonDesktopHeaderContainer,
    SkeletonDesktopHeaderLeft,
} from "./skeletonViewListingPageStyling";
import SkeletonReservationDetails from "./skeletonReservationDetails/SkeletonReservationDetails";

export default function SkeletonViewListingPage() {

    return (
        <>
            <SkeletonDesktopHeaderContainer>
                <SkeletonDesktopHeaderLeft>
                    <img src="https://d292awxalydr86.cloudfront.net/Branding/Anystay.svg" alt="Anystay" />
                </SkeletonDesktopHeaderLeft>
            </SkeletonDesktopHeaderContainer>
            {window.innerWidth >= 768 ? (
                <div style={{ background: '#fafafa' }}>
                    <SkeletonViewListingPageContainer>
                        <SkeletonCarouselPageContainer>
                            <SkeletonCarouselWrapper>
                                <ViewListingFeaturedImage />
                            </SkeletonCarouselWrapper>
                        </SkeletonCarouselPageContainer>
                        <ViewListingContainer>
                            <ViewListingTopContainerWrapper>
                                <ViewListingTopContainer>
                                    <ViewListingTitleWrapper>
                                        <ViewListingTitleTitle />
                                        <ViewListingTitleSubtitle />
                                        <ViewListingTitleAmenities />
                                        <ViewListingSubtitleWrapper>
                                            {/* Empty div to match the actual structure */}
                                        </ViewListingSubtitleWrapper>
                                    </ViewListingTitleWrapper>
                                </ViewListingTopContainer>
                                <ViewListingRightMenuContainer>
                                    <SkeletonReservationDetails />
                                </ViewListingRightMenuContainer>
                            </ViewListingTopContainerWrapper>
                        </ViewListingContainer>
                    </SkeletonViewListingPageContainer>
                </div>
            ) : (
                <>
                    <SkeletonCarouselPageContainer>
                        <SkeletonCarouselWrapper>
                            <ViewListingFeaturedImage />
                        </SkeletonCarouselWrapper>
                    </SkeletonCarouselPageContainer>
                    <ViewListingContainer>
                        <ViewListingTopContainerWrapper>
                            <ViewListingTopContainer>
                                <ViewListingTitleWrapper>
                                    <ViewListingTitleTitle />
                                    <ViewListingTitleSubtitle />
                                    <ViewListingTitleAmenities />
                                    <ViewListingSubtitleWrapper>
                                        {/* Empty div to match the actual structure */}
                                    </ViewListingSubtitleWrapper>
                                </ViewListingTitleWrapper>
                            </ViewListingTopContainer>
                            <ViewListingRightMenuContainer>
                                <SkeletonReservationDetails />
                            </ViewListingRightMenuContainer>
                        </ViewListingTopContainerWrapper>
                    </ViewListingContainer>
                </>
            )}
        </>
    );
}
